import { TreeData } from '../../../models/tree-data';
import { ItemTreeType } from '../../../models/enum/item-tree.enum';
import { TranslateService } from '@ngx-translate/core';
import { Component, EventEmitter, Input, Output } from '@angular/core';



@Component({
  selector: 'app-add-btn',
  templateUrl: './add-btn.component.html',
  styleUrls: ['./add-btn.component.css']
})
export class AddBtnComponent  {
  @Input() isTop: boolean;
  @Input() currentNode: TreeData;
  @Output() addedNode = new EventEmitter;

  constructor(private translate: TranslateService) { }

  addItem(): void {
    const newCustomer =  this.translate.instant('CONSTANTS.NEW_CUSTOMER');
    const newOrg =  this.translate.instant('CONSTANTS.NEW_ORGANIZATION');
    const node: TreeData = {
      Id: null,
      itemTreeType: this.isTop ? ItemTreeType.customer : ItemTreeType.organization,
      isCreate: true,
      obj: {
        name: this.isTop ? newCustomer : newOrg,
      },
      Children: []
    };

    if (this.isTop) {
      this.addedNode.emit(node);
    } else {
      this.addedNode.emit({ currentNode: this.currentNode, node: node });
    }
  }
}

